module.exports = __webpack_public_path__ + "media/images/icon_arrow-rounded-e09149a6447d5a2df89877ad1c43b513.svg";